module.exports = __webpack_public_path__ + "static/UnitedStates_dark-1d5244dc2ca505f077031ff59f30ee69.svg";